import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function () {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/LicenceApplication/GetLicencesRequiringReview";
        console.log("Fetching licenses requiring review from:", url);

        GET(url)
            .then(function (response) {
                if (response.status === 200) {
                    const reviewData = response.data.LicencesRequiringReview || response.data.licencesRequiringReview || [];
                    
                    dispatch({
                        type: "LICENCES_REQUIRING_REVIEW_RETRIEVED",
                        data: reviewData
                    });
                }
                dispatch(CreateDataRetrievalEndedAction());
            }).catch(function (error) {
                console.error("Error fetching licenses requiring review:", error);
                dispatch({
                    type: "LICENCES_REQUIRING_REVIEW_ERROR",
                    error: "Failed to load licenses requiring review"
                });
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
} 